// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__R6GpY"};